import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import lmRules from './default-lm-rules.json';
import { getRoutes } from './routes';
import { getUrlData, getSearchParams, getDataObject } from './colorWallUtils';

ThdAnalytics.init();
NewRelicBridge.init();
whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setLayoutManagerRules(lmRules);
  client.setExperienceRoutes(getRoutes());

  const { color, navBarIndex, brand } = getUrlData(window.location.pathname);

  let dataObject;
  let searchParams;
  let colorNumber;
  let brandName;

  if (window.location.search) {
    searchParams = getSearchParams(window.location.search);
    colorNumber = searchParams.colorNumber;
    brandName = searchParams.brandName;
  }

  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  if (window.location.pathname.includes('Paint-Ideas')) {
    dataObject = await getDataObject(client, color, navBarIndex, brand, colorNumber, brandName);
  }

  client.render(<App
    data={dataObject}
    prefetchPip={client.featureSwitches.prefetchPip}
    productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
  />);
});
